// src/components/Header/Header.tsx

import React, { useState } from "react";
import "./Header.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FiMenu } from "react-icons/fi";

// --- STATE IMPORTS ---
import { RootState } from "../../redux/store";
import { logout } from "../../redux/authSlice";

// --- ICON IMPORTS ---
import searchIcon from "../../assets/images/searchicon.png";
import notificationIcon from "../../assets/images/notificationicon.png";
import chevronDownIcon from "../../assets/images/chevron-down.webp";
import defaultAvatar from "../../assets/images/profile1.png";
import { resolveMediaUrl } from "../../utils/mediaUrl";
import ComingSoonAction from "../ComingSoonAction/ComingSoonAction";

interface HeaderProps {
  title: string;
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ title, onMenuClick }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const user = useSelector((state: RootState) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
  
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };
 
  const getProfileImage = () => resolveMediaUrl(user?.avatarUrl) || defaultAvatar;

  return (
    <header className="header">
      <button className="mobile-menu-btn" onClick={onMenuClick}>
        <FiMenu />
      </button>

      <div className="header-title">
        <h1>{title}</h1>
      </div>

      <div className="header-controls">
        <ComingSoonAction title="Global search — coming soon">
          <div className="search-bar">
            <img src={searchIcon} alt="" aria-hidden />
            <input type="text" placeholder="Search" disabled tabIndex={-1} />
          </div>
        </ComingSoonAction>
        <ComingSoonAction title="Notifications — coming soon">
          <div className="notification-icon">
            <img src={notificationIcon} alt="" aria-hidden />
            <span className="notification-badge">2</span>
          </div>
        </ComingSoonAction>
        <div className="user-profile">
          <div
            className="profile-trigger"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          >
            <img
              src={getProfileImage()}
              alt="User Avatar"
              className="avatar"
              onError={(e) => {
                  e.currentTarget.src = defaultAvatar;
              }}
            />
            <span className="user-name">{user?.name || "Guest"}</span>
            <img
              src={chevronDownIcon}
              alt="Dropdown"
              className="chevron-down"
            />
          </div>

          {isDropdownOpen && (
            <div className="profile-dropdown">
              <div
                className="dropdown-item"
                onClick={() => navigate("/profile-upload")}
              >
                <span>Profile</span>
              </div>
              <div
                className="dropdown-item"
                onClick={() => navigate("/settings")}
              >
                <span>Settings</span>
              </div>
              <div className="dropdown-divider" />
              <div className="dropdown-item logout" onClick={handleLogout}>
                <span>Logout</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;